import { Component, OnInit } from '@angular/core';
import {fadeIn, fadeOut} from '../../../../animations';
import {GlobalSettingsService} from '../../../../services/ui/global-settings.service';

@Component({
  selector: 'binder-session-confirmation',
  templateUrl: './binder-session-confirmation.component.html',
  styleUrls: ['./binder-session-confirmation.component.scss', '../../../stylesheets/job-main.scss'],
  animations: [fadeIn(200), fadeOut(200)]
})
export class BinderSessionConfirmationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    GlobalSettingsService.isGlobalLoaderLoading = false;
    GlobalSettingsService.isSecondaryLoaderLoading = false;
  }
}
